angular.module('impactx.MenuDirectives').directive('ixDeactivateSupplierBasket', function() {
    return {
        restrict: 'E',
        controller: 'DeactivateSupplierBasketCtrl',
        controllerAs: 'deactivateSupplierBasketCtrl',
        templateUrl: 'shared/menu/templates/deactivatesupplierbasket.tmpl.html'
    }
});